export const SORT_DATA = "SORT_DATA";
export const DESCRIPTION_DATA = "DESCRIPTION_DATA"
export const DELETE_CART_DATA = "DELETE_CART_DATA"
export const INCREASE_QTY = "INCCHANGE"
export const DECREASE_QTY = "DECCHANGE"
export const CART_DATA = "cart_DATA";
export const SET_COUNT = "setcount";
export const LOGIN = "login";

